// extracted by mini-css-extract-plugin
export default {"main-container":"sectionOne_main-container__gP5rz"};